import axios from 'ui/utils/axios';
import { IError } from 'ui/interfaces/entities/apiError';
import {
  IResponse as Response,
  IFunctionalLimitations,
  IKnownLanguages,
  IPreferredMethodofContact,
  IPreferredTime,
} from 'ui/interfaces/entities/personalInformation';

export namespace GET {
  export const getUrl = (empi: string) => `/sidebar/patients/${empi}/personal_information`;

  export const service = (empi: string) => axios.get<IResponse>(getUrl(empi));

  export interface IResponse {
    data: Response;
  }

  export type IResponseError = IError;
}

export namespace PUT {
  export const getUrl = (empi: EMPI) => `/sidebar/patients/${empi}/personal_information`;

  export const service = (empi: EMPI, data: IRequest) => {
    return axios.put<IResponse>(getUrl(empi), data);
  };

  export interface IRequest {
    functional_limitations?: IFunctionalLimitations[];
    known_languages?: IKnownLanguages[];
    preferred_method_of_contact?: IPreferredMethodofContact[];
    preferred_time?: IPreferredTime[];
  }

  export interface IResponse {
    message: string;
    success: boolean;
  }

  export type IResponseError = IError;
}
